'use client'

import { CSSProperties } from 'react'
import Box, { BoxProps } from 'shared/components/Box/Box'

type LoadingSpinnerContainerProps = BoxProps<'div'> & {
  height?: string
}

const LoadingSpinnerContainer = ({
  children,
  height = '100vh',
  ...props
}: LoadingSpinnerContainerProps) => {
  const heightStyle: CSSProperties = {
    '--height': height,
  } as CSSProperties

  return (
    <Box style={heightStyle} className="page-container" {...props}>
      {children}
    </Box>
  )
}

export default LoadingSpinnerContainer
